import { render } from "./PaymentHistoryInvoices.vue?vue&type=template&id=0fef5b8f&scoped=true&ts=true"
import script from "./PaymentHistoryInvoices.vue?vue&type=script&lang=ts"
export * from "./PaymentHistoryInvoices.vue?vue&type=script&lang=ts"

import "./PaymentHistoryInvoices.vue?vue&type=style&index=0&id=0fef5b8f&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fef5b8f"]])

export default __exports__